import React from 'react'
import { useCalendar } from './useCalendar';
import { bodyRequest, pathname } from "@react/helpers/fetch"

// components
import MiniCalendar from './miniCalendar'
import Filter       from './filter'
import Settings     from './settings'
import ResourceList from './resourceList'

const CalendarLeft = ({ 

}) => {
  const { state, setState, filter, TOOLS } = useCalendar()
  const SEPARATED = "separated"

  const saveFilter = () => {
    const path   = '/calendar/save_filter'
    const body   = {
      filter: filter
    }

    const url = pathname({ path })
    bodyRequest({ url, body }).then(res => setState({...state, filterResponse: res.success }))
  }

  return(
    <div className="calendar-left">
      <div className="fixed-controls">
        <MiniCalendar />

        <Settings />

        { TOOLS.displayOpen == SEPARATED && <Filter /> }
        
        <ResourceList />

        <button className="save-filter-btn mb-4" onClick={saveFilter} disabled={!!state.filterResponse}>
          {!!state.filterResponse ? state.filterResponse : I18n.t("calendar.save_filter")}
        </button>
      </div>
    </div>
  )
}


export default CalendarLeft
